import { useEffect, useReducer, useState } from "react";
import Container from "../../../Components/Container/Container";
import {
  getEmployeesByLoginId,
  getSubOrdinatesByEmployeeId,
} from "../../../utils/api";
import { FunnelForm, SelectFormField } from "./EmployeesGraph.components";
import useAntSelectStyles from "../../../hooks/useAntSelectStyles";
import styles from "./EmployeesGraph.module.css";
import { fetchWrapper, getCurrentFinancialYear } from "../../../utils/misc";
import ProgressDoughnutChart from "../../../Components/DarQuarterTargetChart/DoughnutWithTarget";
import {
  Button,
  ConfigProvider,
  Flex,
  Modal,
  Spin,
  Table,
  Tabs,
  Tooltip,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import {
  filterReducer,
  funnelCustomerReducer,
  generateCSVData,
  generateFunnelColumns,
  getAchPriceOfAllQuarters,
  getFunnelData,
  getQuarterAchievementPrice,
  getQuarterFunnel,
  getQuarterTarget,
  getRevenueAchPriceOfAllQuarters,
  getSelectedEmployeeName,
  getYearlyFunnel,
  getYearsList,
  quarterTotalDarPrice,
} from "./EmployeesGraph.helpers";
import RouteBar from "../../../Components/RouteBar/RouteBar";
import {
  csvBtnVariants,
  funnelBoxStyles,
  funnelBtnStyles,
  funnelModalStyles,
  initialFunnelFilterState,
  loadingContainerStyles,
  spinElementStyles,
  tableStyles,
  targetChartArray,
} from "./EmployeesGraph.data";
import { getRowClassName } from "../../../helpers/engineerConfirmation/listHelper";
import { HiMiniUserGroup, HiOutlineInformationCircle } from "react-icons/hi2";
import { PiCurrencyInrBold } from "react-icons/pi";
import { CSVLink } from "react-csv";
import { motion } from "framer-motion";
import useProfileData from "../../../hooks/useProfileData";

function EmployeesGraph() {
  const date = new Date();
  const currentMonth = date.getMonth() + 1;
  // useAntSelectStyles();
  const currentYear = getCurrentFinancialYear();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const { profileData } = useProfileData();
  const [formData, setFormData] = useState({
    employeeId: 0,
    subordinateId: 0,
    selectedYear:
      currentMonth >= 4 ? date.getFullYear() + 1 : date.getFullYear(),
  });
  const [employeesUnderLoginId, setEmployeesUnderLoginId] = useState([]);
  const [subordinateList, setSubordinateList] = useState([]);
  const [targets, setTargets] = useState([]);
  const [achievementTarget, setAchivementTarget] = useState(null);
  const [loading, setLoading] = useState(false);
  const [yearlyTarget, setYearlyTarget] = useState(0);
  const [completedYearlyTarget, setCompletedYearlyTarget] = useState(0);
  const [revenueAchievementTargets, setRevenueAchivementTargets] = useState([]);
  const [yearlyRevenueTarget, setYearlyRevenueTarget] = useState(null);
  const [completedYearlyRevenueTarget, setCompletedYearlyRevenueTarget] =
    useState(0);
  const [
    quarterlyCompletedRevenueTargets,
    setQuarterlyCompletedRevenueTargets,
  ] = useState(null);
  const [employeeSelected, setEmployeeSelected] = useState("");
  const [isFunnelModalOpen, setIsFunnelModalOpen] = useState(false);
  const [funnelDataLoading, setFunnelDataLoading] = useState(false);
  const [funnelData, setFunnelData] = useState([]);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isReset, setIsReset] = useState(false);
  const [isFirstRender, setIsFirstRender] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [funnelQuarterData, setFunnelQuarterData] = useState({
    q1: [],
    q2: [],
    q3: [],
    q4: [],
    yearly: [],
  });
  const [funnelTotalPriceLoading, setFunnelTotalPriceLoading] = useState(false);
  const [funnelTotalPriceError, setFunnelTotalPriceError] = useState(false);
  const [funnelCustomersState, dispatch] = useReducer(funnelCustomerReducer, {
    loading: false,
    q1: 0,
    q2: 0,
    q3: 0,
    q4: 0,
    yearly: 0,
    activeFunnelQuarterModal: "",
    error: "",
  });
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
    filters: {},
  });

  const [filterState, filterDispatch] = useReducer(
    filterReducer,
    initialFunnelFilterState,
  );
  const [savedSelectedYear, setSavedSelectedYear] = useState(
    formData.selectedYear,
  );
  const [selectEmpStatus, setSelectEmpStatus] = useState(0);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
  };

  // percentage to divide the total target to get revenue amount.
  let revenuePercentage = 35 / 100;

  async function fetchFunnelQuarterData() {
    setFunnelTotalPriceLoading(true);
    dispatch({ type: "loading" });
    let empIdToFilter = null;

    if (formData.employeeId !== 0 && formData.subordinateId !== 0) {
      empIdToFilter = formData.subordinateId;
    } else if (formData.employeeId !== 0 && formData.subordinateId === 0) {
      empIdToFilter = formData.employeeId;
    } else if (formData.employeeId === 0 && formData.subordinateId === 0) {
      empIdToFilter = userData.loginId;
    } else if (isFirstRender) {
      empIdToFilter = userData.loginId;
    }

    try {
      const yearPassed =
        new Date().getMonth() + 1 >= 4
          ? new Date().getFullYear() + 1
          : new Date().getFullYear();
      const funnelData = await getFunnelData(
        empIdToFilter,
        filterState.callStatusId,
        isFormSubmitted ? formData.selectedYear : yearPassed,
      );
      if (Object.entries(funnelData).length > 0) {
        const q1Data = funnelData["q1"];
        const q2Data = funnelData["q2"];
        const q3Data = funnelData["q3"];
        const q4Data = funnelData["q4"];

        const q1UniqueCustomersData = [];
        const q2UniqueCustomersData = [];
        const q3UniqueCustomersData = [];
        const q4UniqueCustomersData = [];

        if (q1Data) {
          q1Data.forEach((element) => {
            if (!q1UniqueCustomersData.includes(element.custName)) {
              q1UniqueCustomersData.push(element.custName);
            } else {
              return;
            }
          });

          dispatch({
            type: "addQ1",
            value: q1UniqueCustomersData.length,
          });

          setFunnelQuarterData((prev) => {
            return {
              ...prev,
              q1: q1Data,
            };
          });
        }
        if (q2Data) {
          q2Data.forEach((element) => {
            if (!q2UniqueCustomersData.includes(element.custName)) {
              q2UniqueCustomersData.push(element.custName);
            } else {
              return;
            }
          });

          dispatch({
            type: "addQ2",
            value: q2UniqueCustomersData.length,
          });

          setFunnelQuarterData((prev) => {
            return {
              ...prev,
              q2: q2Data,
            };
          });
        }
        if (q3Data) {
          q3Data.forEach((element) => {
            if (!q3UniqueCustomersData.includes(element.custName)) {
              q3UniqueCustomersData.push(element.custName);
            } else {
              return;
            }
          });

          dispatch({
            type: "addQ3",
            value: q3UniqueCustomersData.length,
          });
          setFunnelQuarterData((prev) => {
            return {
              ...prev,
              q3: q3Data,
            };
          });
        }
        if (q4Data) {
          q4Data.forEach((element) => {
            if (!q4UniqueCustomersData.includes(element.custName)) {
              q4UniqueCustomersData.push(element.custName);
            } else {
              return;
            }
          });

          dispatch({
            type: "addQ4",
            value: q4UniqueCustomersData.length,
          });

          setFunnelQuarterData((prev) => {
            return {
              ...prev,
              q4: q4Data,
            };
          });
        }

        dispatch({
          type: "addYearly",
          value:
            q1UniqueCustomersData.length +
            q2UniqueCustomersData.length +
            q3UniqueCustomersData.length +
            q4UniqueCustomersData.length,
        });

        setFunnelQuarterData((prev) => {
          return {
            ...prev,
            yearly: [...q1Data, ...q2Data, ...q3Data, ...q4Data],
          };
        });
        setFunnelTotalPriceLoading(false);
      }
    } catch (err) {
      console.log(err.message);
      setFunnelTotalPriceError(err.message);
      dispatch({ type: "error", value: err.message });
    } finally {
      dispatch({ type: "loaded" });
      setFunnelTotalPriceLoading(false);
    }
  }

  useEffect(() => {
    async function initialLoad(selectEmpStatus) {
      setLoading(true);
      try {
        const employeeList = await getEmployeesByLoginId(selectEmpStatus);
        const yearPassed =
          new Date().getMonth() + 1 >= 4
            ? new Date().getFullYear() + 1
            : new Date().getFullYear();
        await fetchAllSubordinatesData(yearPassed);
        if (Array.isArray(employeeList)) {
          const transformedEmpList = employeeList.map((employee) => ({
            key: employee.employeeId,
            value: employee.employeeId,
            text: employee.employeeName,
          }));
          setEmployeesUnderLoginId(transformedEmpList);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }

    // fetchFunnelQuarterData();
    initialLoad();
  }, []);

  useEffect(() => {
    const handleReload = (reloadOption) => {
      if (reloadOption === "reload") {
        setIsFirstRender(true);
      } else {
        setIsFirstRender(false);
      }
    };
    window.addEventListener("load", () => {
      handleReload("reload");
    });

    if (isFormSubmitted || isFirstRender || isReset) {
      fetchFunnelQuarterData();
    }

    return () => {
      window.removeEventListener("load", () => {
        handleReload("do-not-reload");
      });
    };
  }, [
    formData.employeeId,
    userData.loginId,
    formData.subordinateId,
    isFormSubmitted,
    isFirstRender,
  ]);

  const fetchChartData = async (employeeId, subordinateId, year, empStatus) => {
    let data1 = null;
    let data2 = null;

    // setLoading(true);
    if (employeeId !== 0 && subordinateId === 0) {
      data1 = await getQuarterAchievementPrice(employeeId, year);
      data2 = await getQuarterTarget(employeeId, year, empStatus);
    }

    if (formData.subordinateId !== 0) {
      data1 = await getQuarterAchievementPrice(subordinateId, year);
      data2 = await getQuarterTarget(subordinateId, year, empStatus);
    }

    function setViewData({ data1, data2 }) {
      console.log({ data1, data2 })
      if (data1 && data2) {
        setYearlyTarget(data2?.totalYearTarget); // done
        setYearlyRevenueTarget(data2?.totalYearRevenueTarget); // done
        setTargets(data2?.updatedData); // done
        setRevenueAchivementTargets(data2?.updatedRevenueData); // done

        setAchivementTarget({
          // done
          q1_AchPrice: data1?.achPrice?.q1_AchPrice,
          q2_AchPrice: data1?.achPrice?.q2_AchPrice,
          q3_AchPrice: data1?.achPrice?.q3_AchPrice,
          q4_AchPrice: data1?.achPrice?.q4_AchPrice,
        });

        setQuarterlyCompletedRevenueTargets({
          q1: data1?.revenueAchPrice?.q1_RevenueAchPrice * 0.35,
          q2: data1?.revenueAchPrice?.q2_RevenueAchPrice * 0.35,
          q3: data1?.revenueAchPrice?.q3_RevenueAchPrice * 0.35,
          q4: data1?.revenueAchPrice?.q4_RevenueAchPrice * 0.35,
        });

        const completedTargetAmt =
          data1?.achPrice?.q1_AchPrice +
          data1?.achPrice?.q2_AchPrice +
          data1?.achPrice?.q3_AchPrice +
          data1?.achPrice?.q4_AchPrice;
        const completedRevenueTargetAmt =
          data1?.revenueAchPrice?.q1_RevenueAchPrice +
          data1?.revenueAchPrice?.q2_RevenueAchPrice +
          data1?.revenueAchPrice?.q3_RevenueAchPrice +
          data1?.revenueAchPrice?.q4_RevenueAchPrice;

        setCompletedYearlyTarget(completedTargetAmt); // done
        setCompletedYearlyRevenueTarget(completedRevenueTargetAmt * 0.35);
      }
    }

    if (data1 && data2) {
      setViewData({ data1, data2 });
      return true;
    } else {
      const loginIdData1 = await getQuarterAchievementPrice(
        profileData ? profileData.loginId : userData.loginId,
        year,
      );

      const loginIdData2 = await getQuarterTarget(
        profileData ? profileData.loginId : userData.loginId,
        year,
        empStatus
      );

      setViewData({ data1: loginIdData1, data2: loginIdData2 });

      // message.error("Please select an employee");
      return true;
      // setYearlyTarget(0);
      // setYearlyRevenueTarget(0);
      // setTargets([]);
      // setRevenueAchivementTargets([]);

      // setAchivementTarget(null)

      // setQuarterlyCompletedRevenueTargets(null)

      // setCompletedYearlyTarget(0);
      // setCompletedYearlyRevenueTarget(0);
    }
    // setLoading(false);
  };

  async function fetchAllSubordinatesData(
    year = new Date().getMonth() + 1 >= 4
      ? new Date().getFullYear() + 1
      : new Date().getFullYear(),
  ) {
    // const allTargetData = await fetchWrapper(
    //   "GET",
    //   `${localStorage.getItem("BaseUrl")}/Tracking/Alldarquartertarget?loginId=${userData?.loginId}&Year=${year}`,
    // );
    const allTargetData = await fetchWrapper(
      "GET",
      `${localStorage.getItem("BaseUrl")}/Tracking/AllDarQuarterTarget2?LOGINID=${userData?.loginId}&Year=${year}&EmpStatus=${selectEmpStatus}`,
    )
    const allTargetAchPriceData = await fetchWrapper(
      "GET",
      `${localStorage.getItem("BaseUrl")}/Dar/AllEmpQuarterChartData?loginId=${userData?.loginId}&Year=${year}&EmpStatus=${selectEmpStatus}`,
    );
    if (allTargetData.resCode === 200) {
      let targets = [];
      let revenueTargets = [];

      let verticalMap = {
        3: 'psg',
        6: 'esg'
      };

      const vertical = verticalMap[userData?.vertical];

      for (let key in allTargetData?.resData) {
        const lowKey = key.toLowerCase();
        const targetValue = (lowKey.includes('target') && lowKey.includes(vertical) && (!lowKey.includes('total'))) && parseFloat(allTargetData?.resData[key]);

        const revenueValue = (lowKey.includes('revenue') && lowKey.includes(vertical) && (!lowKey.includes('total'))) && parseFloat(allTargetData?.resData[key]);

        const totalTargetKeyValue = (lowKey.includes('target') && lowKey.includes(vertical) && (lowKey.includes('total') && (!lowKey.includes('revenue')))) && parseFloat(allTargetData?.resData[key]);

        const totalRevTargetKeyValue = (lowKey.includes('target') && lowKey.includes(vertical) && (lowKey.includes('total') && (lowKey.includes('revenue')))) && parseFloat(allTargetData?.resData[key]);


        // for total target
          if(!isNaN(totalTargetKeyValue) && typeof totalTargetKeyValue !== "boolean") {
            setYearlyTarget((totalTargetKeyValue * 100000));
          }

          // for total revenue
          if(!isNaN(totalRevTargetKeyValue) && typeof totalRevTargetKeyValue !== "boolean") {
            setYearlyRevenueTarget((totalRevTargetKeyValue * 100000));
          }

          // for targets
          if (!isNaN(targetValue) && typeof targetValue !== "boolean") {
            targets.push({
              target: Number.parseFloat(targetValue * 100000) // convert the value into lacs.
            })
          }

          // for revenue targets
          if (!isNaN(revenueValue) && typeof revenueValue !== "boolean") {
            revenueTargets.push({
              revenueTarget: Number.parseFloat((revenueValue * 100000))
            })
          }
      }

      setRevenueAchivementTargets(revenueTargets);
      setTargets(targets);
    }

    if (allTargetAchPriceData.resCode === 200) {
      const achPriceObj = getAchPriceOfAllQuarters(
        allTargetAchPriceData?.resData,
      );
      const revenueAchPriceObj = getRevenueAchPriceOfAllQuarters(
        allTargetAchPriceData?.resData,
      );

      setAchivementTarget({
        q1_AchPrice: achPriceObj.q1,
        q2_AchPrice: achPriceObj.q2,
        q3_AchPrice: achPriceObj.q3,
        q4_AchPrice: achPriceObj.q4,
      });

      const totalCompletedTargetAmt =
        achPriceObj.q1 + achPriceObj.q2 + achPriceObj.q3 + achPriceObj.q4;

      const totalCompletedRevenueTargetAmt =
        (revenueAchPriceObj.q1 +
          revenueAchPriceObj.q2 +
          revenueAchPriceObj.q3 +
          revenueAchPriceObj.q4) *
        revenuePercentage;

      setQuarterlyCompletedRevenueTargets({
        q1: revenueAchPriceObj.q1 * revenuePercentage,
        q2: revenueAchPriceObj.q2 * revenuePercentage,
        q3: revenueAchPriceObj.q3 * revenuePercentage,
        q4: revenueAchPriceObj.q4 * revenuePercentage,
      });

      setCompletedYearlyTarget(totalCompletedTargetAmt);
      setCompletedYearlyRevenueTarget(totalCompletedRevenueTargetAmt);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await fetchChartData(
      formData.employeeId,
      formData.subordinateId,
      formData.selectedYear,
      selectEmpStatus
    );

    try {
      if (result) {
        setIsReset(false);
        const selectedLoginId =
          formData.subordinateId !== 0
            ? formData.subordinateId
            : formData.employeeId;
        const selectedEmployee = await getSelectedEmployeeName(selectedLoginId);
        const inActiveEmployeeSelected = [
          ...employeesUnderLoginId,
          ...subordinateList,
        ].find((employee) => employee.value === selectedLoginId);
        if (selectedEmployee) {
          setEmployeeSelected(selectedEmployee.empName);
        } else if (
          !selectedEmployee &&
          employeesUnderLoginId.length > 0 &&
          !inActiveEmployeeSelected
        ) {
          await fetchAllSubordinatesData(formData.selectedYear);
        }

        if (!selectedEmployee && inActiveEmployeeSelected) {
          setEmployeeSelected(inActiveEmployeeSelected.text);
        }
        setIsFormSubmitted(true);
        setIsFirstRender(false);
        setSavedSelectedYear(formData.selectedYear);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const resetHandler = async (e) => {
    setLoading(true);
    try {
      if (formData.employeeId !== 0 || formData.subordinateId !== 0) {
        setFormData((prev) => ({
          ...prev,
          employeeId: 0,
          subordinateId: 0,
        }));
      }
      setFormData((prev) => ({
        ...prev,
        selectedYear:
          currentMonth >= 4 ? date.getFullYear() + 1 : date.getFullYear(),
      }));
      setEmployeeSelected("");
      const yearPassed =
        currentMonth >= 4 ? date.getFullYear() + 1 : date.getFullYear();
      await fetchAllSubordinatesData(yearPassed);
      setIsFormSubmitted(false);
      setSavedSelectedYear(
        currentMonth >= 4 ? date.getFullYear() + 1 : date.getFullYear(),
      );
      setIsFirstRender(false);
      setIsReset(true);
      setSelectEmpStatus(0);
    } catch (err) {
      console.log(err, "error in resetHandler");
    } finally {
      setLoading(false);
    }
  };

  // tabs
  const EmpStatusList = [
    { key: 1, value: 0, text: "All" },
    { key: 2, value: 1, text: "Active" },
    { key: 3, value: 2, text: "In-Active" },
  ];
  const items = [
    {
      key: "1",
      label: "Target",
      children: (
        <section className={styles.chartSection}>
          <section className={styles.container}>
            <h5>
              Quarterly Sales Achievement & Target for FY{" "}
              {savedSelectedYear - 1}-
              {savedSelectedYear.toString().slice(2, 4)}{" "}
            </h5>
          </section>
          {/* targets */}
          <section className={styles.chartContainer}>
            <section className={styles.box}>
              <section className={styles.quarterBoxes}>
                {targetChartArray.map((quarter, index) => {
                  return loading ? (
                    <div style={loadingContainerStyles}>
                      <Spin
                        indicator={<LoadingOutlined spin />}
                        size="default"
                        style={spinElementStyles}
                      />
                    </div>
                  ) : (
                    <div key={index}>
                      <ProgressDoughnutChart
                        name={quarter.quarter}
                        value={
                          achievementTarget
                            ? achievementTarget[quarter.achivementQuarter]
                            : 0
                        }
                        // maxValue={
                        //   targets.length > 0
                        //     ? targets[index].target === 0
                        //       ? 1
                        //       : targets[index].target
                        //     : 1
                        // }
                        maxValue={
                          targets[index]?.target
                            ? targets[index].target === 0
                              ? 1
                              : targets[index].target
                            : 1
                        }
                        width={210}
                        height={155}
                        enableModalEvent
                        data={{
                          loginId:
                            formData.subordinateId !== 0
                              ? formData.subordinateId
                              : formData.employeeId
                                ? formData.employeeId
                                : profileData
                                  ? profileData.loginId
                                  : userData.loginId,
                          year: savedSelectedYear,
                        }}
                        id={`target-${quarter.quarter.toLowerCase()}`}
                      />
                    </div>
                  );
                })}
                <div id={styles.yearlyBoxInsideQuarterBoxes}>
                  {loading ? (
                    <div style={loadingContainerStyles}>
                      <Spin
                        indicator={<LoadingOutlined spin />}
                        size="default"
                        style={spinElementStyles}
                      />
                    </div>
                  ) : (
                    <ProgressDoughnutChart
                      name="Yearly"
                      value={completedYearlyTarget || 0}
                      maxValue={yearlyTarget || 1}
                      width={210}
                      height={155}
                      enableModalEvent
                      data={{
                        // loginId: (formData.subordinateId !== 0 ? formData.subordinateId : formData.employeeId),
                        loginId:
                          formData.subordinateId !== 0
                            ? formData.subordinateId
                            : formData.employeeId
                              ? formData.employeeId
                              : profileData
                                ? profileData.loginId
                                : userData.loginId,
                        year: savedSelectedYear,
                      }}
                      id="target-yearly"
                    />
                  )}
                </div>
              </section>
              <section className={styles.yearlyBox}>
                <div>
                  {loading ? (
                    <div style={loadingContainerStyles}>
                      <Spin
                        style={spinElementStyles}
                        indicator={<LoadingOutlined spin />}
                        size="default"
                      />
                    </div>
                  ) : (
                    <ProgressDoughnutChart
                      name="Yearly"
                      value={completedYearlyTarget || 0}
                      maxValue={yearlyTarget || 1}
                      width={210}
                      height={155}
                      enableModalEvent
                      data={{
                        // loginId: (formData.subordinateId !== 0 ? formData.subordinateId : formData.employeeId),
                        loginId:
                          formData.subordinateId !== 0
                            ? formData.subordinateId
                            : formData.employeeId
                              ? formData.employeeId
                              : profileData
                                ? profileData.loginId
                                : userData.loginId,
                        year: savedSelectedYear,
                      }}
                      id="target-yearly"
                    />
                  )}
                </div>
              </section>
            </section>
          </section>
        </section>
      ),
    },
    {
      key: "2",
      label: "Revenue Target",
      children: (
        <section className={styles.chartSection}>
          <section className={styles.container}>
            <h5>
              Quarterly Revenue Achievement & Target for FY{" "}
              {savedSelectedYear - 1}-
              {savedSelectedYear.toString().slice(2, 4)}{" "}
            </h5>
          </section>

          {/* revenue achivement targets */}
          <section className={styles.chartContainer}>
            <section className={styles.box}>
              <section className={styles.quarterBoxes}>
                {targetChartArray.map((quarter, index) => {
                  return loading ? (
                    <div style={loadingContainerStyles}>
                      <Spin
                        style={spinElementStyles}
                        indicator={<LoadingOutlined spin />}
                        size="default"
                      />
                    </div>
                  ) : (
                    <div key={index}>
                      <ProgressDoughnutChart
                        name={quarter.quarter}
                        value={
                          quarterlyCompletedRevenueTargets
                            ? quarterlyCompletedRevenueTargets[quarter.key]
                            : 0
                        }
                        maxValue={
                          revenueAchievementTargets.length > 0
                            ? revenueAchievementTargets[index].revenueTarget ===
                              0
                              ? 1
                              : revenueAchievementTargets[index].revenueTarget
                            : 1
                        }
                        width={210}
                        height={155}
                        enableModalEvent
                        data={{
                          // loginId: (formData.subordinateId !== 0 ? formData.subordinateId : formData.employeeId),
                          loginId:
                            formData.subordinateId !== 0
                              ? formData.subordinateId
                              : formData.employeeId
                                ? formData.employeeId
                                : profileData
                                  ? profileData.loginId
                                  : userData.loginId,
                          year: savedSelectedYear,
                        }}
                        id={`revenue-${quarter.quarter.toLowerCase()}`}
                      />
                    </div>
                  );
                })}

                <div id={styles.yearlyBoxInsideQuarterBoxes}>
                  {loading ? (
                    <div style={loadingContainerStyles}>
                      <Spin
                        style={spinElementStyles}
                        indicator={<LoadingOutlined spin />}
                        size="default"
                      />
                    </div>
                  ) : (
                    <ProgressDoughnutChart
                      name="Yearly"
                      value={completedYearlyRevenueTarget || 0}
                      maxValue={yearlyRevenueTarget || 1}
                      width={210}
                      height={155}
                      enableModalEvent
                      data={{
                        // loginId: (formData.subordinateId !== 0 ? formData.subordinateId : formData.employeeId),
                        loginId:
                          formData.subordinateId !== 0
                            ? formData.subordinateId
                            : formData.employeeId
                              ? formData.employeeId
                              : profileData
                                ? profileData.loginId
                                : userData.loginId,
                        year: savedSelectedYear,
                      }}
                      id="revenue-yearly"
                    />
                  )}
                </div>
              </section>

              <section className={styles.yearlyBox}>
                <div>
                  {loading ? (
                    <div style={loadingContainerStyles}>
                      <Spin
                        style={spinElementStyles}
                        indicator={<LoadingOutlined spin />}
                        size="default"
                      />
                    </div>
                  ) : (
                    <ProgressDoughnutChart
                      name="Yearly"
                      value={completedYearlyRevenueTarget || 0}
                      maxValue={yearlyRevenueTarget || 1}
                      width={210}
                      height={155}
                      enableModalEvent
                      data={{
                        // loginId: (formData.subordinateId !== 0 ? formData.subordinateId : formData.employeeId),
                        loginId:
                          formData.subordinateId !== 0
                            ? formData.subordinateId
                            : formData.employeeId
                              ? formData.employeeId
                              : profileData
                                ? profileData.loginId
                                : userData.loginId,
                        year: savedSelectedYear,
                      }}
                      id="revenue-yearly"
                    />
                  )}
                </div>
              </section>
            </section>
          </section>
        </section>
      ),
    },
    {
      key: "3",
      label: "Funnel",
      children: (
        <section className={styles.chartSection}>
          <FunnelForm
            filterDispatch={filterDispatch}
            fetchFunnelQuarterData={fetchFunnelQuarterData}
          />
          <section className={styles.chartContainer}>
            <section className={styles.box}>
              <section className={styles.quarterBoxes}>
                {targetChartArray.map((quarter, index) => {
                  return (
                    <div key={index} style={funnelBoxStyles}>
                      <div
                        style={{
                          marginTop: "1rem",
                          minHeight: "100%",
                          padding: "0 0.65rem 0 1rem",
                          width: "100%",
                        }}
                      >
                        <h5
                          style={{
                            textAlign: "center",
                            marginBottom: "1rem",
                          }}
                        >
                          {quarter.quarter.toUpperCase()}
                        </h5>
                        {/* total customers */}
                        <Tooltip
                          title={`No. of Customers for ${quarter.quarter.toUpperCase()}`}
                        >
                          <div className={styles.customerIconRow}>
                            <HiMiniUserGroup
                              style={{ fontSize: "20px", color: "blue" }}
                            />
                            {/* calculate this dynamically */}
                            <span
                              style={{
                                display: "inline-block",
                              }}
                            >
                              {!funnelCustomersState.loading &&
                                funnelCustomersState.error === "" ? (
                                funnelCustomersState[quarter.key]
                              ) : !funnelCustomersState.loading &&
                                funnelCustomersState.error !== "" ? (
                                <span>{funnelCustomersState.error}</span>
                              ) : (
                                <span
                                  style={{
                                    background: "lightgrey",
                                    padding: "0 2rem",
                                  }}
                                ></span>
                              )}
                            </span>
                          </div>
                        </Tooltip>

                        {/* total target */}
                        <Tooltip
                          title={`Sum of price for all DAR entries of ${quarter.quarter.toUpperCase()}`}
                        >
                          <div className={styles.customerIconRow}>
                            <PiCurrencyInrBold
                              style={{
                                fontSize: "18px",
                                color: "red",
                              }}
                            />
                            {/* calculate this dynamically */}
                            <span
                              style={{
                                display: "inline-block",
                              }}
                            >
                              {!funnelTotalPriceLoading &&
                                !funnelTotalPriceError ? (
                                `${(quarterTotalDarPrice(funnelQuarterData[quarter.key]) / 10000000).toFixed(2)} Cr.`
                              ) : !funnelTotalPriceLoading &&
                                funnelTotalPriceError ? (
                                <span>{funnelTotalPriceError}</span>
                              ) : (
                                <span
                                  style={{
                                    background: "lightgrey",
                                    padding: "0 2rem",
                                  }}
                                ></span>
                              )}
                            </span>
                          </div>
                        </Tooltip>
                        <Flex
                          align="center"
                          justify="start"
                          style={{ marginTop: "1rem" }}
                        >
                          <Button
                            type="primary"
                            size="middle"
                            style={{
                              width: "50%",
                              backgroundColor: "#5b8c00",
                            }}
                            title="Funnel"
                            // style={funnelBtnStyles}
                            onClick={async () => {
                              setIsFunnelModalOpen(true);
                              dispatch({
                                type: "setActiveQuarter",
                                value: quarter.key.toUpperCase(),
                              });
                              try {
                                setFunnelDataLoading(true);
                                setFunnelData([]);
                                const resetFilters = {};

                                if (
                                  tableParams?.filters &&
                                  typeof tableParams?.filters === "object"
                                ) {
                                  for (let key in tableParams.filters) {
                                    tableParams.filters[key] = null;
                                    resetFilters[key] =
                                      tableParams.filters[key];
                                  }

                                  setTableParams((prev) => {
                                    return {
                                      ...prev,
                                      filters: resetFilters,
                                    };
                                  });
                                }

                                let empIdToFilter = null;

                                if (
                                  formData.employeeId !== 0 &&
                                  formData.subordinateId !== 0 &&
                                  isFormSubmitted
                                ) {
                                  empIdToFilter = formData.subordinateId;
                                } else if (
                                  formData.employeeId !== 0 &&
                                  formData.subordinateId === 0 &&
                                  isFormSubmitted
                                ) {
                                  empIdToFilter = formData.employeeId;
                                } else if (
                                  formData.employeeId === 0 &&
                                  formData.subordinateId === 0
                                ) {
                                  empIdToFilter = userData.loginId;
                                } else {
                                  empIdToFilter = userData.loginId;
                                }
                                const res = await getQuarterFunnel(
                                  quarter.key,
                                  empIdToFilter,
                                  formData.selectedYear,
                                  filterState.callStatusId,
                                );
                                if (res.length > 0) {
                                  setFunnelData(res);
                                  const dataForCSV = generateCSVData(res);
                                  setCsvData(dataForCSV);
                                }
                              } catch (err) {
                                console.log(err.message);
                              } finally {
                                setFunnelDataLoading(false);
                              }
                            }}
                          >
                            {/* <FilterOutlined style={{ fontSize: '14px' }} /> */}
                            <HiOutlineInformationCircle
                              style={{ fontSize: "14px" }}
                            />
                            <span>Funnel</span>
                          </Button>
                        </Flex>
                      </div>
                    </div>
                  );
                })}

                <div
                  id={styles.yearlyBoxInsideQuarterBoxes}
                  style={{
                    minWidth: "230px",
                    minHeight: "180px",
                  }}
                >
                  <Flex align="center" justify="end">
                    <Button
                      title="Funnel"
                      type="primary"
                      size="middle"
                      style={{
                        width: "50%",
                        backgroundColor: "#5b8c00",
                      }}
                      // style={funnelBtnStyles}
                      onClick={async () => {
                        setIsFunnelModalOpen(true);
                        dispatch({ type: "setActiveQuarter", value: "Yearly" });
                        try {
                          setFunnelDataLoading(true);
                          setFunnelData([]);
                          let empIdToFilter = null;

                          if (
                            formData.employeeId !== 0 &&
                            formData.subordinateId !== 0 &&
                            isFormSubmitted
                          ) {
                            empIdToFilter = formData.subordinateId;
                          } else if (
                            formData.employeeId !== 0 &&
                            formData.subordinateId === 0 &&
                            isFormSubmitted
                          ) {
                            empIdToFilter = formData.employeeId;
                          } else if (
                            formData.employeeId === 0 &&
                            formData.subordinateId === 0
                          ) {
                            empIdToFilter = userData.loginId;
                          } else {
                            empIdToFilter = userData.loginId;
                          }
                          const res = await getYearlyFunnel(
                            empIdToFilter,
                            filterState.callStatusId,
                            formData.selectedYear,
                          );
                          if (res.length > 0) {
                            setFunnelData(res);
                            const dataForCSV = generateCSVData(res);
                            setCsvData(dataForCSV);
                          }
                        } catch (err) {
                          console.log(err.message);
                        } finally {
                          setFunnelDataLoading(false);
                        }
                      }}
                    >
                      <HiOutlineInformationCircle
                        style={{ fontSize: "14px" }}
                      />
                      {/* <FilterOutlined style={{ fontSize: '14px' }} /> */}
                      <span>Funnel</span>
                    </Button>
                  </Flex>
                  <div
                    style={{
                      marginTop: "1rem",
                      minHeight: "100%",
                      padding: "0 0.65rem 0 1rem",
                      width: "100%",
                    }}
                  >
                    <p>Yearly</p>
                    {/* total customers */}
                    <Tooltip title={`No. of Customers of this financial year`}>
                      <div className={styles.customerIconRow}>
                        <HiMiniUserGroup
                          style={{ fontSize: "20px", color: "blue" }}
                        />
                        {/* calculate this dynamically */}
                        <span
                          style={{
                            display: "inline-block",
                            minWidth: "100px",
                          }}
                        >
                          {!funnelCustomersState.loading &&
                            funnelCustomersState.error === "" ? (
                            funnelCustomersState.yearly
                          ) : !funnelCustomersState.loading &&
                            funnelCustomersState.error !== "" ? (
                            <span>{funnelCustomersState.error}</span>
                          ) : (
                            <span
                              style={{
                                background: "lightgrey",
                                padding: "0 2rem",
                                minWidth: "100px",
                              }}
                            ></span>
                          )}
                        </span>
                      </div>
                    </Tooltip>

                    {/* total target */}
                    <Tooltip
                      title={`Sum of price for all DAR entries of this financial year`}
                    >
                      <div className={styles.customerIconRow}>
                        <PiCurrencyInrBold
                          style={{
                            fontSize: "18px",
                            color: "red",
                          }}
                        />
                        {/* calculate this dynamically */}
                        <span
                          style={{
                            display: "inline-block",
                            minWidth: "100px",
                          }}
                        >
                          {!funnelTotalPriceLoading &&
                            !funnelTotalPriceError ? (
                            `${(quarterTotalDarPrice(funnelQuarterData["yearly"]) / 10000000).toFixed(2)} Cr.`
                          ) : !funnelTotalPriceLoading &&
                            funnelTotalPriceError ? (
                            <span>{funnelTotalPriceError}</span>
                          ) : (
                            <span
                              style={{
                                background: "lightgrey",
                                padding: "0 2rem",
                                minWidth: "100px",
                              }}
                            ></span>
                          )}
                        </span>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </section>

              <section className={styles.yearlyBox}>
                <div
                  style={{
                    minWidth: "230px",
                    minHeight: "180px",
                  }}
                >
                  <div
                    style={{
                      // marginTop: '1rem',
                      minHeight: "100%",
                      padding: "0rem 0.65rem 0 1rem",
                      minWidth: "100%",
                      marginTop: "1.5rem",
                    }}
                  >
                    <h5 style={{ textAlign: "center", marginBottom: "1rem" }}>
                      Yearly
                    </h5>
                    {/* total customers */}
                    <Tooltip title={`No. of Customers of this financial year`}>
                      <div className={styles.customerIconRow}>
                        <HiMiniUserGroup
                          style={{ fontSize: "20px", color: "blue" }}
                        />
                        {/* calculate this dynamically */}
                        <span
                          style={{
                            display: "inline-block",
                            minWidth: "100px",
                          }}
                        >
                          {!funnelCustomersState.loading &&
                            funnelCustomersState.error === "" ? (
                            funnelCustomersState.yearly
                          ) : !funnelCustomersState.loading &&
                            funnelCustomersState.error !== "" ? (
                            <span>{funnelCustomersState.error}</span>
                          ) : (
                            <span
                              style={{
                                background: "lightgrey",
                                padding: "0 2rem",
                                minWidth: "100px",
                              }}
                            ></span>
                          )}
                        </span>
                      </div>
                    </Tooltip>

                    {/* total target */}
                    <Tooltip
                      title={`Sum of price for all DAR entries of this financial year`}
                    >
                      <div className={styles.customerIconRow}>
                        {/* <TbTargetArrow
                                                    style={{
                                                        fontSize: "20px",
                                                    }}
                                                /> */}
                        <PiCurrencyInrBold
                          style={{
                            fontSize: "18px",
                            color: "red",
                          }}
                        />
                        {/* calculate this dynamically */}
                        <span
                          style={{
                            display: "inline-block",
                            minWidth: "100px",
                          }}
                        >
                          {!funnelTotalPriceLoading &&
                            !funnelTotalPriceError ? (
                            `${(quarterTotalDarPrice(funnelQuarterData["yearly"]) / 10000000).toFixed(2)} Cr.`
                          ) : !funnelTotalPriceLoading &&
                            funnelTotalPriceError ? (
                            <span>{funnelTotalPriceError}</span>
                          ) : (
                            <span
                              style={{
                                background: "lightgrey",
                                padding: "0 2rem",
                                minWidth: "100px",
                              }}
                            ></span>
                          )}
                        </span>
                      </div>
                    </Tooltip>

                    <Flex align="center" justify="start">
                      <Button
                        title="Funnel"
                        // style={funnelBtnStyles}
                        type="primary"
                        size="middle"
                        style={{
                          marginTop: "1.25rem",
                          backgroundColor: "#5b8c00",
                        }}
                        onClick={async () => {
                          setIsFunnelModalOpen(true);
                          dispatch({
                            type: "setActiveQuarter",
                            value: "Yearly",
                          });
                          try {
                            setFunnelDataLoading(true);
                            setFunnelData([]);
                            let empIdToFilter = null;

                            if (
                              formData.employeeId !== 0 &&
                              formData.subordinateId !== 0 &&
                              isFormSubmitted
                            ) {
                              empIdToFilter = formData.subordinateId;
                            } else if (
                              formData.employeeId !== 0 &&
                              formData.subordinateId === 0 &&
                              isFormSubmitted
                            ) {
                              empIdToFilter = formData.employeeId;
                            } else if (
                              formData.employeeId === 0 &&
                              formData.subordinateId === 0
                            ) {
                              empIdToFilter = userData.loginId;
                            } else {
                              empIdToFilter = userData.loginId;
                            }

                            const res = await getYearlyFunnel(
                              empIdToFilter,
                              filterState.callStatusId,
                              formData.selectedYear,
                            );
                            if (res.length > 0) {
                              setFunnelData(res);
                              const dataForCSV = generateCSVData(res);
                              setCsvData(dataForCSV);
                            }
                          } catch (err) {
                            console.log(err.message);
                          } finally {
                            setFunnelDataLoading(false);
                          }
                        }}
                      >
                        {/* <FilterOutlined style={{ fontSize: '14px' }} /> */}
                        <HiOutlineInformationCircle
                          style={{ fontSize: "14px" }}
                        />
                        <span>Funnel</span>
                      </Button>
                    </Flex>
                  </div>
                </div>
              </section>
            </section>
          </section>
        </section>
      ),
    },
  ];

  return (
    <>
      <RouteBar heading="Employees Graph" />
      <Container>
        <form onSubmit={handleSubmit}>
          <div className="row mb-3">
            <SelectFormField
              labelFor="empstatus"
              value={selectEmpStatus}
              labelText="Emp Status"
              onChange={async (EmpStatus) => {
                const filterdEmp = await getEmployeesByLoginId(EmpStatus);

                if (filterdEmp.length > 0) {
                  const transformedEmpList = filterdEmp.map((employee) => ({
                    key: employee.employeeId,
                    value: employee.employeeId,
                    text: employee.employeeName,
                  }));

                  setEmployeesUnderLoginId(transformedEmpList);
                }

                setSelectEmpStatus(EmpStatus);
              }}
              options={EmpStatusList}
            />

            <SelectFormField
              labelFor="employee"
              labelText="Employee"
              value={formData.employeeId === 0 ? "Select" : formData.employeeId}
              onChange={async (selectedEmployee) => {
                const subordinates =
                  await getSubOrdinatesByEmployeeId(selectedEmployee, selectEmpStatus);
                setIsFirstRender(false);
                setIsFormSubmitted(false);
                if (Array.isArray(subordinates)) {
                  if (subordinates.length > 0) {
                    const transformedSubordinateList = subordinates.map(
                      (employee) => ({
                        key: employee.employeeId,
                        value: employee.employeeId,
                        text: employee.employeeName,
                      }),
                    );

                    setSubordinateList(transformedSubordinateList);
                  } else {
                    setSubordinateList([]);
                  }
                }
                setFormData((prev) => {
                  return {
                    ...prev,
                    employeeId: selectedEmployee,
                    subordinateId: 0,
                  };
                });
              }}
              options={employeesUnderLoginId}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />

            <SelectFormField
              labelFor="subordinate"
              labelText="Sub Ordinate"
              value={
                formData.subordinateId === 0 ? "Select" : formData.subordinateId
              }
              onChange={async (selectedEmployee) => {
                setIsFirstRender(false);
                setIsFormSubmitted(false);
                setFormData((prev) => {
                  return {
                    ...prev,
                    subordinateId: selectedEmployee,
                  };
                });
              }}
              options={subordinateList}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </div>
          <div className="row">
            <SelectFormField
              labelFor="selectedYear"
              labelText="Financial Year"
              value={formData.selectedYear}
              onChange={async (selectedYear) => {
                setIsFirstRender(false);
                setIsFormSubmitted(false);
                setFormData((prev) => {
                  return {
                    ...prev,
                    selectedYear,
                  };
                });
              }}
              options={getYearsList()}
            />
          </div>
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button type="submit" className={`${styles.formBtn} searchBtn`}>
              Submit
            </button>

            <button
              onClick={resetHandler}
              type="button"
              className={`${styles.formBtn} searchBtn`}
            >
              Reset
            </button>
          </div>
        </form>
        {employeeSelected ? (
          <h4 id={styles.employeeHeading}>Employee - {employeeSelected}</h4>
        ) : (
          <h4 id={styles.employeeHeading}>All Subodinates</h4>
        )}
        <Tabs defaultActiveKey="1" items={items} />
        <Modal
          style={funnelModalStyles}
          // title={`Funnel - ${funnelCustomersState.activeFunnelQuarterModal}`}
          title={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <p>
                Funnel - {funnelCustomersState.activeFunnelQuarterModal}, FY:{" "}
                {savedSelectedYear - 1}-{savedSelectedYear}
              </p>

              <motion.button
                style={{
                  margin: "1rem 0rem",
                  border: "1px solid black",
                  borderRadius: "4px",
                  boxShadow: "0px 0px 3px lightgrey",
                  background: "white",
                  padding: "2px 16px",
                }}
                variants={csvBtnVariants}
                initial="hidden"
                animate={!funnelDataLoading ? "visible" : "hidden"}
              >
                <CSVLink
                  data={csvData}
                  filename={`Funnel List - ${funnelCustomersState.activeFunnelQuarterModal}`}
                  style={{
                    fontSize: "14px",
                    color: "black",
                  }}
                >
                  CSV
                </CSVLink>
              </motion.button>
            </div>
          }
          open={isFunnelModalOpen}
          onOk={() => setIsFunnelModalOpen(false)}
          onCancel={() => setIsFunnelModalOpen(false)}
          cancelButtonProps={{
            style: {
              display: "none",
            },
          }}
        >
          <ConfigProvider theme={tableStyles}>
            <Table
              loading={funnelDataLoading}
              columns={generateFunnelColumns(funnelData)}
              scroll={{ x: 1700 }}
              bordered
              dataSource={funnelData}
              pagination={tableParams.pagination}
              onChange={handleTableChange}
              style={{ overflowX: "auto" }}
              rowClassName={getRowClassName}
              rowKey={() => Math.floor(Math.random() * 123456)}
            />
          </ConfigProvider>
        </Modal>
      </Container>
    </>
  );
}

export default EmployeesGraph;
